export const getConfig = (name) => window?.__env__?.[name] ?? process.env[name];

export default getConfig;
